var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{on:{"onSubmit":_vm.onSubmit},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Sin acceso. ")]},proxy:true},{key:"body",fn:function(){return [_vm._v(" No tiene acceso a esta aplicación. ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }